import styled from 'styled-components'
import { colors } from '../../../../assets/colors'

const KateNumber = styled.div`
  font-size: 0.725rem;
  color: ${colors.mediumGrey};
`

export default KateNumber
